<template>
    <div>
        <v-row align="center" justify="space-between" class="d-md-none px-3 mb-5 header-container">
            <div class="responsive-header"></div>
            <v-img 
                :src="require('@/assets/logo-cours-thales-white.png')" 
                width="150px" 
                max-width="150px" 
                class="d-md-none logo-white mt-1 ml-8"
                :class="{ 'cursor-pointer': step == 1 }"
                @click="step == 1 ? openCoursThales() : null"
            >
            </v-img>
            <div class="d-flex align-center step-log mr-10 mt-3">
                <v-icon
                    v-if="isUserLog || step != 1"
                    @click.stop="drawer = !drawer"
                    icon="mdi-menu"
                    color="white"
                ></v-icon>
                <v-navigation-drawer v-model="drawer" temporary overlay>
                    <v-list density="compact" nav>
                        <v-list-item @click="showDetails" prepend-icon="mdi-account-details" title="Récapitulatif"></v-list-item>
                        <v-list-item v-if="isUserLog" @click="logout" prepend-icon="mdi-logout" title="Déconnexion"></v-list-item>
                        <v-list-item @click="drawer = false" prepend-icon="mdi-close" title="Fermer"></v-list-item>
                    </v-list>
                </v-navigation-drawer>
            </div>
        </v-row>

        <v-row align=center justify=space-between class="px-3">
            <v-img 
                :src="require('@/assets/logo-cours-thales.png')" 
                width="150px" 
                max-width="150px" 
                class="d-none d-md-block"
                :class="{ 'cursor-pointer': step == 1 }"
                @click="step == 1 ? openCoursThales() : null"
            ></v-img>
            <div class="d-flex align-center">
                <v-btn v-if="isUserLog" @click="logout" class="font-weight-bold logout-link d-none d-md-block" variant="text">
                    D<span class="text-lowercase">éconnexion</span>
                </v-btn>
            </div>
        </v-row>
        <v-row class="mt-10 d-md-none px-3">
            <v-col cols="12" class="text-left pb-0">
                <div class="title-form-mobile">Formulaire d'inscription</div>
            </v-col>
            <v-col cols="12" class="text-left pt-1">
                <div class="subtitle-contact">Contactez-nous au 01 42 05 41 36 si besoin.</div>
            </v-col>
        </v-row>
        <v-row class="mt-8 d-none d-md-block px-3">
            <v-col cols="12" class="text-left pb-0">
                <div class="title-form">Formulaire d'inscription</div>
            </v-col>
            <v-col cols="12" class="text-left pt-1">
                <div class="subtitle-contact">Contactez-nous au 01 42 05 41 36 si besoin.</div>
            </v-col>
        </v-row>
        <stepper :step="step" class="mt-4"/>
        <v-row align=end class="mt-6 mb-2 px-3">
            <div class="text-start title">{{ title }}</div>
        </v-row>
                
    </div>
</template>

<script>

import Stepper from '@/components/layout/StepperBase.vue';

export default {

    components: {
        Stepper,
    },

    props: {
        step: String,
        title: String,
        alreadyClient: Boolean,
    },

    data() {
        return {
            drawer: false,
            isUserLog: false,
            addNewChild: false
        }
    },

    methods: {

        logout() {
            this.$store.dispatch('auth/logout')
            .then(() => {
                window.location.href = '/user-creation'
            })
        },

        openCoursThales() {
            window.open('https://www.cours-thales.fr', '_blank');
        },

        showDetails() {
            this.$store.dispatch('showInfoPanel');
        }

    },

    created() {
        this.isUserLog = this.$store.state.auth.isAuth;
        this.addNewChild = this.$route.query.action === 'add-new-child' ? true : false
    }
}

</script>

<style scoped>

.header-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: #06113a;
    padding: 10px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.responsive-header {
    background-image: url(./../../assets/panel-info-background.jpg);
    background-size: cover;
    background-position: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 90px;
}

.responsive-header::after {
    height: 90px;
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #06113a;
    opacity: 0.8;
}

.logo-white {
    z-index: 10;
}

.details {
    font-size: 15px;
}

.step-log {
    z-index: 10;
}

.title-form {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.25;
    color: #06113a;
    display: inline-block;
    position: relative;
    padding-bottom: 10px;
}

.title-form::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 52px;
    height: 3px;
    border-radius: 2px;
    background: linear-gradient(90deg, #a9343f 0 10px, #f2cd78 10px 100%);
}

.title-form-mobile {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.25;
    color: #06113a;
    display: inline-block;
    position: relative;
    padding-bottom: 8px;
}

.title-form-mobile::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 40px;
    height: 3px;
    border-radius: 2px;
    background: linear-gradient(90deg, #a9343f 0 8px, #f2cd78 8px 100%);
}

.title {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.3;
    color: #06113a;
    border-left: 3px solid #a9343f;
    padding-left: 12px;
}

.login-link {
    line-height: 38px;
    font-size: 16px;
    color: #A9343F;
}

.logout-link {
    color: #a9343f !important;
    letter-spacing: 0.02em;
}

.logout-link:hover {
    color: #841520 !important;
}

.subtitle-contact {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 15px !important;
    font-weight: 400 !important;
    line-height: 1.4;
    color: #868ebb !important;
}

.cursor-pointer {
    cursor: pointer;
}

</style>
